/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeclineQuoteRequest
 */
export interface DeclineQuoteRequest {
    /**
     * 
     * @type {string}
     * @memberof DeclineQuoteRequest
     */
    reason: DeclineQuoteRequestReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof DeclineQuoteRequest
     */
    message: string;
}


/**
 * @export
 */
export const DeclineQuoteRequestReasonEnum = {
    AlreadyStaffed: 'ALREADY_STAFFED',
    NoLongerAvailable: 'NO_LONGER_AVAILABLE',
    DirectHire: 'DIRECT_HIRE',
    NotRelevant: 'NOT_RELEVANT',
    PriceOverBudget: 'PRICE_OVER_BUDGET'
} as const;
export type DeclineQuoteRequestReasonEnum = typeof DeclineQuoteRequestReasonEnum[keyof typeof DeclineQuoteRequestReasonEnum];


/**
 * Check if a given object implements the DeclineQuoteRequest interface.
 */
export function instanceOfDeclineQuoteRequest(value: object): value is DeclineQuoteRequest {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function DeclineQuoteRequestFromJSON(json: any): DeclineQuoteRequest {
    return DeclineQuoteRequestFromJSONTyped(json, false);
}

export function DeclineQuoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeclineQuoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'message': json['message'],
    };
}

export function DeclineQuoteRequestToJSON(value?: DeclineQuoteRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reason': value['reason'],
        'message': value['message'],
    };
}

